// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"sia-z","subtitle":"tia-z","wrapper":"uia-z","leftArrow":"via-z","rightArrow":"wia-z"};